<svelte:options accessors/>
<script>
    import {createEventDispatcher, onMount} from "svelte";
    import NauiButton from "../atoms/NauiButton.svelte";

    export let month;
    export let year;
    export let events = [];
    export let eventTags = [];

    let dispatch = createEventDispatcher();
    let tagLabels = {};

    let firstDay;
    let lastDay;
    let gridFirstDay;
    let gridLastDay;
    let offsetPre;
    let offsetPos;
    let loop;
    let week = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo']

    let days = [];

    onMount(() => {
        loadCalendar();
        addCalendarEvents();
    });

    function loadCalendar() {
        days = [];
        firstDay = new Date(year, month);
        offsetPre = firstDay.getDay();
        gridFirstDay = new Date(year, month, offsetPre === 0 ? -5 : 2 - offsetPre);

        lastDay = new Date(year, month + 1, 0);
        offsetPos = lastDay.getDay();
        gridLastDay = new Date(year, month + 1, offsetPos === 0 ? 0 : 7 - offsetPos);

        // Rellena todas las fechas de la cuadrícula
        loop = new Date(gridFirstDay);
        while (loop <= gridLastDay) {
            let mth = loop.getMonth() + 1;
            let day = loop.getDate();

            if (mth < 10) {
                mth = '0' + mth;
            }
            if (day < 10) {
                day = '0' + day;
            }

            const dateIndex = loop.getFullYear() + '-' + mth + '-' + day;

            days = [...days, {
                date: new Date(loop),
                dateIndex: dateIndex,
                disabled: ((loop > lastDay) || (loop < firstDay)),
                dayEvents: []
            }];
            let newDate = loop.setDate(loop.getDate() + 1);
            loop = new Date(newDate);
        }
    }

    function addCalendarEvents() {
        for (const tag of eventTags) {
            tagLabels[tag.slug] = {};
        }
        for (const event of events) {
            const day = days.find(d => d.dateIndex === event.date);
            if (!event.list) {
                continue;
            }
            for (const item of event.list) {
                if (!tagLabels[item.tag][event.date]) {
                    tagLabels[item.tag][event.date] = 0;
                }
                tagLabels[item.tag][event.date] += 1;
            }
            if (day) {
                day.dayEvents = event.list;
            }
        }
    }

    function monthName(monthIndex) {
        const monthsNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        return monthsNames[monthIndex];
    }

    function nextMonth() {
        const currentM = month;
        const currentY = year;
        month = new Date(currentY, currentM + 1).getMonth();
        year = new Date(currentY, currentM + 1).getFullYear();
        loadCalendar();
        submitData({month: month + 1, year}, 'get', '')
            .then(res => {
                events = res.events;
                addCalendarEvents();
            });
    }

    function prevMonth() {
        const currentM = month;
        const currentY = year;
        month = new Date(currentY, currentM - 1).getMonth();
        year = new Date(currentY, currentM - 1).getFullYear();
        loadCalendar();
        submitData({month: month + 1, year}, 'get', '')
            .then(res => {
                events = res.events;
                addCalendarEvents();
            });
    }

    function getTag(slug) {
        return eventTags.filter((x) => x.slug === slug)[0];
    }

    function clicDate(data) {
        const title = `${data.date.getDate()} de ${monthName(data.date.getMonth())}`;
        dispatch('selectDate', {data, title});
    }

</script>
<div>
    <div class="box-b mb-1 ">
        <div class="box-l sx-1">
            <div class="box-l sx-i">
                <div>
                    <NauiButton iconFamily="fas" color="secondary" icon="chevron-left" on:click={prevMonth}/>
                </div>
                <div>
                    <NauiButton iconFamily="fas" color="secondary" icon="chevron-right" on:click={nextMonth}/>
                </div>
            </div>
            <h2>{monthName(month)} de {year}</h2>
        </div>
        <div class="box-r sx-ii">
            {#each eventTags as tag}
                <div style="background: {tag.background}; color: {tag.color}; font-size:0.8rem; font-weight:bold"
                     class="tag radius py-i px-ii">
                    {tag.label}
                </div>
            {/each}
        </div>

    </div>


    <div class="grid-7 calendar">
        {#each week as weekday (weekday)}
            <div class="weekday text-c back-gray box">
                <p><strong>{weekday}</strong></p>
            </div>
        {/each}

        {#each days as day (day.date)}
            <div on:click={clicDate.bind(this, day)} class="p-i date" style="min-height:120px"
                 class:disabled={day.disabled}>
                <div class="mb-ii">
                    <p class="text-r">{day.date.getDate()}</p>
                </div>
                {#each eventTags as tag}
                    {#if tagLabels[tag.slug][day.dateIndex]}
                        <div class="tag py-i px-ii radius mb-i text-c"
                             style="background: {tag.background}; color: {tag.color}; font-size:0.8rem; font-weight:bold">
                            {tagLabels[tag.slug][day.dateIndex]}
                        </div>
                    {/if}
                {/each}
            </div>
        {/each}
    </div>


</div>
<style>
    .grid-7 {
        grid-template-columns: repeat(7, 14.2857%);
    }

    .calendar {
        border-collapse: collapse;
        border-top: 1px solid var(--border-color);
        border-left: 1px solid var(--border-color);
    }

    .calendar .date {
        min-height: 120px;
        border-right: 1px solid var(--border-color);
        border-bottom: 1px solid var(--border-color);
    }

    .calendar .date p {
        font-weight: 600;
        font-size: .9rem;
    }

    .date {
        cursor: pointer;
    }

    .date.disabled {
        background: var(--back-gray);
    }

    .date.disabled p {
        color: #888;
    }

    .weekday {
        min-height: 30px;
        border-right: 1px solid var(--border-color);
        border-bottom: 1px solid var(--border-color);
    }
</style>
